import { INotification } from './../../domain/notification.interface';
export const GET_NOTIFICATION = 'GET_NOTIFICATION';
export const CLEAR_NOTIFICATION = 'CLEAR_NOTIFICATION';
export const INCREMENT_LOADING = 'INCREMENT_LOADING';
export const DECREMENT_LOADING = 'DECREMENT_LOADING';

export const returnNotification = (notification: INotification) => {
  return {
    type: GET_NOTIFICATION,
    payload: notification,
  };
};

export const clearNotification = () => {
  return {
    type: CLEAR_NOTIFICATION,
  };
};

export const incrementLoading = () => {
  return {
    type: INCREMENT_LOADING,
  };
};

export const decrementLoading = () => {
  return {
    type: DECREMENT_LOADING,
  };
};
